// https://vuex.vuejs.org/en/actions.html

import subscriptionsService from '@/services/subscriptionsService'
import store from '@/store'

export default {
  async RefreshSubscriptions (context) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Refreshing Subscriptions')
    var subscriptionApiResult = await subscriptionsService.getOverview()
    if (subscriptionApiResult.success === false) {
      store.dispatch('RemoveLoadingMessage', loadingId)
      return subscriptionApiResult
    }
    context.commit('refreshSubscriptions', subscriptionApiResult.value)
    if (store.state.customers.data.length === 0) {
      await store.dispatch('RefreshCustomers')
    }
      await store.dispatch('EnsureProductInformationForSubscriptionsIsAvailable')
    store.dispatch('RemoveLoadingMessage', loadingId)
    return subscriptionApiResult
  },
  async EnsureProductInformationForSubscriptionsIsAvailable (context) {
    if (store.state.products.list.length === 0) {
      await store.dispatch('RefreshProducts')
    }
    var unavailableProductVariantIds = store.state.subscriptions.data
      .filter(s => {
        return (
          store.state.products.list.some(p => {
            return p.variants.some(v => v.uid === s.productVariantId)
          }) === false
        )
      })
      .map(s => s.productVariantId)
      .filter((v, i, a) => a.indexOf(v) === i)
    if (unavailableProductVariantIds.length > 0) {
      store.dispatch('GetProductsByVariantUids', unavailableProductVariantIds)
    }
  },
  async SilentRefreshSubscription (context, uid) {
    // this function is used to poll for changes, no need to show loader
    var subscriptionApiResult = await subscriptionsService.get(uid)
    if (subscriptionApiResult.success) {
      context.commit('updateSubscription', subscriptionApiResult.value)
    }
  },
  async UnloadSubscription (context, uid) {
    // this function is used to poll for changes or react to changes, no need to show loader
    context.commit('unloadSubscription', uid)
  },
  async UpdateSubscriptionQuantity (context, params) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Sending update subscription quantity request')
    var apiResult = await subscriptionsService.updateQuantity(params.subscription.uid, params.newQuantity)
    if (apiResult.success === false) {
      store.dispatch('RemoveLoadingMessage', loadingId)
      return false
    }
    // todo: remove this when SignalR is implemented
    context.dispatch('AddPollingEntity', {
      dispatch: 'SilentRefreshSubscription',
      dispatchParam: params.subscription.uid,
      checkup: 'SubscriptionHistoryUpdated',
      checkupParam: {
        uid: params.subscription.uid,
        historyCount: params.subscription.history.length,
      },
      succesMessage: 'Subscription updated',
      failedMessage: 'Subscription update timeout',
    })
    store.dispatch('RemoveLoadingMessage', loadingId)
    return true
  },
  async cancelSubscription (context, subscriptionUid) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Canceling Subscription')
    var cancelSubscriptionApiResult = await subscriptionsService.cancelSubscription(subscriptionUid)
    if (cancelSubscriptionApiResult.success) {
      context.commit('unloadSubscription', subscriptionUid)
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return cancelSubscriptionApiResult
  },

  // Todo: Remove when we have a functional SignalR Hub
  async GetSubscriptionForCustomer (context, params) {
    var apiResult = await subscriptionsService.getForCustomer(params)
    if (apiResult.success === false) {
      return
    }
    context.commit('updateSubscription', apiResult.value)
  },
  async SubscriptionExistsForCustomer ({ state }, params) {
    return state.data.some(i => i.customerId === params.customerId && i.productVariantId === params.variantId)
  },
  async SubscriptionHistoryUpdated ({ state }, params) {
    return state.data.some(i => i.uid === params.uid && i.history.length !== params.historyCount)
  },
  async ResetSubscriptions (context) {
    context.commit('refreshSubscriptions', [])
  },
}
